export const storeTranslations = {
  STORE_TITLE: 'Download Tranzer',
  STORE_SUBTITLE: 'En reis vanaf nu in 3 simpele stappen'
};
